export interface ProductComparisonPriceSet {
	price: number;
}

export interface PriceComparisonDiscount {
	nonDiscountedPrice: number;
	discountPercentage: number;
	visible: boolean;
}

export const defaultProductsComparison = {
	nonDiscountedPrice: 0,
	discountPercentage: 0,
	visible: false,
};

export type DiscountVendorEligibility = {
	stock?: number | null;
	available?: boolean | null;
	disabled?: boolean | null;
};

export function isEligibleVendorForDiscount(
	vendor: DiscountVendorEligibility,
): boolean {
	if (typeof vendor.stock === "number" && vendor.stock <= 0) {
		return false;
	}
	if (vendor.available === false) {
		return false;
	}
	if (vendor.disabled === true) {
		return false;
	}
	return true;
}

export function getNextDistinctPrice(
	vendorsSortedByPrice: { price: number }[],
): number | undefined {
	const cheapestPrice = vendorsSortedByPrice.at(0)?.price;
	if (cheapestPrice === undefined) {
		return undefined;
	}
	return vendorsSortedByPrice.find((vendor) => vendor.price > cheapestPrice)
		?.price;
}

export function calculateProductsComparisonDiscount(
	originalVendorPriceSet?: ProductComparisonPriceSet,
	secondLowestVendorPriceSet?: ProductComparisonPriceSet,
): PriceComparisonDiscount {
	if (
		!originalVendorPriceSet ||
		!secondLowestVendorPriceSet ||
		secondLowestVendorPriceSet.price <= 0
	) {
		return defaultProductsComparison;
	}

	const originalPrice = originalVendorPriceSet.price / 100;
	const lowestPrice = secondLowestVendorPriceSet.price / 100;
	const discount = ((lowestPrice - originalPrice) / lowestPrice) * 100;
	const visible = Math.abs(discount) > 5;

	return {
		nonDiscountedPrice: secondLowestVendorPriceSet.price,
		discountPercentage: discount,
		visible,
	};
}
